<script>
  import { Router } from "svelte-router-spa";
  var password = getCookie("id");
  function getCookie(k) {
    var v = document.cookie.match("(^|;) ?" + k + "=([^;]*)(;|$)");
    return v ? v[2] : null;
  }

  function checkAuth() {
    document.cookie = `id=${password}`;
    fetch("/l/isauthorized").then(data => {
      if (data.status == 200) isAuthorized = true;
    });
  }

  checkAuth();

  function changeCookie(e) {
    if (e.key != "Enter") return;
    document.cookie = `id=${password}`;
    fetch("/l/isauthorized").then(data => {
      if (data.status == 200) isAuthorized = true;
    });
  }

  var isAuthorized = false;
</script>

{#if isAuthorized}
  <Router />
{:else}
  <h3>Κωδικός:</h3>
  <input bind:value={password} on:keyup={e => changeCookie(e)} />
  <input
    class="btn btn-primary btn-sm"
    style="margin-top: -0.25em"
    type="button"
    value="Σύνδεση"
    on:click={() => checkAuth()} />
{/if}
